export const getAdminAuthConfig = () => {
  const stored = localStorage.getItem("AdminEcomme");

  if (!stored) {
    return { headers: {} };
  }

  try {
    const admin = JSON.parse(stored);
    const token = admin?.token;

    if (!token) {
      return { headers: {} };
    }

    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  } catch (error) {
    return { headers: {} };
  }
};
